/**
 * Analytics — dispara page_view do GA4 a cada navegação client-side (SPA).
 * Renderiza null; é totalmente inerte quando VITE_GA_ID não está configurado.
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analyticsEnabled, initAnalytics, trackPageView } from "@/lib/analytics";

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (analyticsEnabled) initAnalytics();
  }, []);

  useEffect(() => {
    if (analyticsEnabled) trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default Analytics;
